import React from 'react'
import Breadcrumbs from '../../components/Global/Breadcrumbs'
import {
    Container,
} from 'reactstrap'

import DataTable from './components/Datatable'

const Index = () => {
    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs
                        title="Mis Conceptos"
                        breadcrumbItem={`Listado de conceptos`}
                        parentLink={`/servicios`}
                    />
                    <DataTable />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Index
